export function ThrowModuleAlreadyExist(parentModule:any, moduleName:String){
    if(parentModule){
        throw new Error(
            `${moduleName} has already been loaded. Import core module in app module only`
        )
    }
}
